import React from 'react';
import { Stack, TextField } from '@mui/material';

interface RateFieldsRowProps {
    wageIndex: number | null;
    lrop: number | null;
    nlop: number | null;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RateFieldsRow: React.FC<RateFieldsRowProps> = ({
    wageIndex,
    lrop,
    nlop,
    onChange
}) => {
    return (
        <Stack direction="row" spacing={2}>
            <TextField
                label="Wage Index"
                name="wageIndex"
                type="number"
                value={wageIndex || ''}
                onChange={onChange}
                fullWidth
                inputProps={{ step: 0.0001, min: 0 }}
            />
            <TextField
                label="LROP"
                name="lrop"
                type="number"
                value={lrop || ''}
                onChange={onChange}
                fullWidth
                inputProps={{ step: 0.01, min: 0 }}
            />
            <TextField
                label="NLOP"
                name="nlop"
                type="number"
                value={nlop || ''}
                onChange={onChange}
                fullWidth
                inputProps={{ step: 0.01, min: 0 }}
            />
        </Stack>
    );
};
